import type { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  navHeading: {
    display: "flex",
    flexWrap: "wrap",
    marginRight: "15px",
    flexDirection: "row",
    "& > button": {
      width: "auto",
    },
  },
  navTitle: {
    maxWidth: 600,
    fontSize: "1.6rem",
    paddingTop: "4px",
    "@media (max-width:499px)": {
      paddingBottom: 10,
    },
  },
  navCog: {
    marginLeft: 10,
  },
  navButton: {
    flex: 1,
    fontSize: 14,
    height: 33,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 10,
    border: "1px solid lightgrey",
    height: "78.8vh",
    // marginTop: "-15%",
  },
  heading: {
    flex: 1,
    // marginTop: "15%",
    marginBottom: "15%",
  },
  leftContent: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column" as const,
    boxSizing: "border-box" as const,
    overflow: "hidden",
  },
  rightContent: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column" as const,
    boxSizing: "border-box" as const,
    overflow: "hidden",
  },
  contentPanelActive: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
    backgroundColor: "#fff",
  },
  crateRoot: {
    display: "flex",
    flexDirection: "column" as const,
    width: "100%",
    height: "100dvh",
    overflow: "hidden",
  },
  crateNavbar: {
    width: "100%",
  },
  crateFooter: {
    width: "100%",
  },
  crateBody: {
    display: "flex",
    flex: 1,
    minHeight: 0,
    width: "100%",
    gap: theme.spacing(2),
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column" as const,
      padding: `${theme.spacing(1)} ${theme.spacing(1)}`,
    },
    [theme.breakpoints.up("md")]: {
      flexDirection: "row" as const,
      alignItems: "stretch",
    },
  },
  crateLeft: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column" as const,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: "33.33%",
    },
  },
  crateRight: {
    flex: 1,
    display: "flex",
    flexDirection: "column" as const,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: "66.67%",
    },
  },
  toolbarActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexGrow: 0.7,
    justifyContent: "flex-end",

    "& > .MuiButton-root": {
      width: "100px",
      maxWidth: "100px",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    "& > .MuiFormControl-root": {
      width: "250px",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
      "& > .MuiFormLabel-root": {
        [theme.breakpoints.up("md")]: {
          display: "none",
        },
      },
    },
  },
  drawerMenu: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  drawerContainer: {
    minWidth: 240,
    padding: 20,
    "& > .MuiDivider-root": {
      marginTop: 10,
    },
  },
  drawerContent: {
    "& > div": {
      marginTop: 20,
    },
    "& > h5": {
      marginTop: 20,
    },
    "& > button": {
      marginTop: 20,
    },
  },
  sbuxLogo: {
    height: 51,
    width: 51,
    [theme.breakpoints.down("md")]: {
      height: 40,
      width: 40,
    },
  },
  appName: {
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    fontWeight: "700 !important",
    flexGrow: 1,
    marginLeft: "10px !important",
  },
  recordingButtons: {
    display: "inline-flex",
    float: "left",
    position: "absolute",
    left: 300,
  },
});

export default styles;
